import { render, staticRenderFns } from "./couponBtn.vue?vue&type=template&id=378bdc19&scoped=true&"
import script from "./couponBtn.vue?vue&type=script&lang=js&"
export * from "./couponBtn.vue?vue&type=script&lang=js&"
import style0 from "./couponBtn.vue?vue&type=style&index=0&id=378bdc19&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378bdc19",
  null
  
)

export default component.exports